<template>
  <div class="staticCampaign">
    <div class="container-router">
      <div class="title">
        <h1 class="medium-title">Price List</h1>
        <ul class="title__menu">
          <router-link tag="li" :to="{name: 'billboardpricelist'}">Billboard</router-link>
        </ul>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar/Desktop'
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { mapGetters } from 'vuex';

export default {
  name: 'adx-',
  components: {
    "adx-sidebar": SideBar,
    'adx-loading': Loading,
    'adx-pagination': Pagination
  },
  props: {

  },
  data() {
    return {
      items: [],
      isLoading: false,
      currentPage: 1,
      maxPage: 1,
    }
  },
  computed: {
    ...mapGetters({
      user: 'account',
    }),
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    const { page } = this.$route.query
    if(page){
      this.currentPage = parseInt(page)
    }
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
